import DomainEntity from '@/models/DomainEntity'

export default class StateAvailableStaff extends DomainEntity {
  static get collectionName() {
    return 'stateavailablestaff/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: [],
    }
  }
}
